module.exports = __webpack_public_path__ + "img/level3addon_mining_tool.97822872.png";